import http from './request'

// 获取弹窗信息
export const getDialogInfo = (data) => {
  return http({
    url: '/promotion/dialog/getInfo',
    method: 'post',
    data
  })
}

// 额外奖励进度
export const getTaskExtraRewardProcess = (data) => {
  return http({
    url: '/promotion/TaskExtraReward/getProcess',
    method: 'post',
    data
  })
}

// 更新额外奖励
export const updateExtraReward = (data) => {
  return http({
    url: '/promotion/TaskExtraReward/updateReward',
    method: 'post',
    data
  })
}

// 当用户已过新手任务，且超过24小时未产生首充，则当用户再次打开时，获取追加的任务信息
export const getAppendTaskInfo = (data) => {
  return http({
    url: '/user/Pwa/getAppendTaskInfo',
    method: 'post',
    data
  })
}

// pwa 首页 获取完成待领取的任务列表
export const getFinishTaskList = (data) => {
  return http({
    url: '/user/Pwa/getFinishTaskList',
    method: 'post',
    data
  })
}

// 领取任务
export const acceptCrownBoxTask = (data) => {
  return http({
    url: '/user/Pwa/acceptTask',
    method: 'post',
    data
  })
}

// 订单事件上报接口
export const reportOrderEvent = (data) => {
  return http({
    url: '/advertCenter/Order/reportOrderEvent',
    method: 'post',
    data
  })
}

export const crownBoxRegister = (data) => {
  return http({
    url: `/user/CrownBox/register`,
    method: 'post',
    data
  })
}

/**
 * 获取任务信息
 * @param {*} data
 * @returns
 */
export const liFaFaActivityGetInfo = (data) => {
  return http({
    url: `/promotion/LiFaFaActivity/getInfo`,
    method: 'post',
    data
  })
}

/**
 * 检查用户是否加入群
 * @param {*} data
 * @returns
 */
export const liFaFaCheckUserJoinStatus = (data) => {
  return http({
    url: `/promotion/LiFaFaActivity/checkUserJoinStatus`,
    method: 'post',
    data
  })
}
/**
 * 验证任务完成情况领取奖励
 * @param {*} data
 * @returns
 */
export const liFaFaActivityClaimReward = (data) => {
  return http({
    url: `/promotion/LiFaFaActivity/claimReward`,
    method: 'post',
    data
  })
}

// 完成任务
export const liFaFaActivityFinishTask = (data) => {
  return http({
    url: `/promotion/LiFaFaActivity/finishTask`,
    method: 'post',
    data
  })
}
// 普通任务列表
export const advertTaskList = (data) => {
  return http({
    url: '/user/advert/task/list',
    method: 'post',
    data
  })
}
